﻿import * as React from "react";
import "./Loader.scss";
import loadingImage from "../../assets/loading-backdrop.png";
import spinner from "../../assets/loading-spinner.png";

interface LoaderProps {
    title?: string;
    description?: string;
}

const Loader: React.FunctionComponent<LoaderProps> = (props: LoaderProps) => {
    const { title, description } = props;

    return (
        <div className="container-loader">
            <div className="container-loader-inner">
                <div className="container-images">
                    <img src={loadingImage} id="loading-background" alt="" />
                    <img src={spinner} id="loading-spinner" alt="" />
                </div>
                { title && <span className="title">{title}</span> }
                { description && <span className="description">{description}</span> }
            </div>
        </div>
    );
};

export default Loader;